<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-access-requests">
  <div class="org-admin-access-requests--layout">
    <app-org-admin-sidebar class="org-admin-access-requests--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-access-requests--content">
      <app-page-header
        [titleOverride]="pageTitle"
        [descriptionOverride]="pageDescription"
      ></app-page-header>
      <div class="access-requests-container">
        <div *ngIf="!isPoliciesTab" class="tabs-container">
          <div class="tabs-header" *ngIf="showInnerTabs">
            <button
              *ngIf="showAssetRequestTab"
              class="tab-button"
              [class.active]="activeTab === 'assetRequest'"
              (click)="setActiveTab('assetRequest')"
              type="button"
            >
              Asset Request
            </button>
            <button
              *ngIf="showPublishAssetsTab"
              class="tab-button"
              [class.active]="activeTab === 'publishAssets'"
              (click)="setActiveTab('publishAssets')"
              type="button"
            >
              Publish Assets
            </button>
          </div>

          <div class="tab-content-wrapper">
            <div
              class="tab-content"
              *ngIf="activeTab === 'assetRequest' && showAssetRequestTab"
            >
              <app-asset-request conversationRoute="/org-admin/access-requests"></app-asset-request>
            </div>

            <div
              class="tab-content"
              *ngIf="activeTab === 'publishAssets' && showPublishAssetsTab"
            >
              <app-publish-assets></app-publish-assets>
            </div>
          </div>
        </div>

        <div *ngIf="isPoliciesTab">
          <app-created-policies
            policyPortal="org-admin"
            policyListType="created"
          ></app-created-policies>
        </div>
      </div>
    </div>
  </div>
</div>
